import { StyledLinkButton } from './LinkButton.styles';

export type LinkButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
};

const LinkButton = ({ children, onClick }: LinkButtonProps) => {
  return (
    <StyledLinkButton onClick={onClick}>
      {children}
    </StyledLinkButton>
  );
};

export default LinkButton;
